export default {
    getRawTablesTypesList: state => {
        return state.tablesTypesList;
    },
    getSelectedRawTablesTypesObjects: state => {
        return state.filteredRawTablesTypesObjects;
    },
    getSelectedRawTablesTypesList: state => {
        return state.selectedTablesTypesList;
    },
    getCustomReportFilters: state => {
        return {
            rawTablesTypes: state.selectedTablesTypesList,
        };
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/rawDataPartnersReport/getters.js